// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d86ee7db","453":"6163e663","455":"51fed290","977":"89465e4f"}[chunkId] + ".chunk.js";
};